import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        user: {}
    },
    getters: {
        user(state){
            return state.user;
        }
    },
    mutations: {
        setUserInfo(state, data){
            state.user = data
        }
    },
    actions: {
        LoadUserInfo({ commit }, data){
            let url = process.env.NODE_ENV !== 'production' ? 'user.json' : 'user/' + data;

            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        commit('setUserInfo' ,data);
                        resolve(true);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js